import { useEffect } from 'react'
import {
  applyBrandCssVariables,
  applyDocumentTitle,
  applyFavicon,
  ContractPageBranding,
  formatBrandingDocumentTitle,
  hasActiveBranding,
  normalizeContractPageBranding,
} from '../utils/contractPageBranding'

export function useApplyContractPageBranding(
  branding?: Partial<ContractPageBranding> | null,
  enabled = true,
  documentName?: string | null
): ContractPageBranding {
  const normalized = normalizeContractPageBranding(branding)
  const brandingDocumentTitle = formatBrandingDocumentTitle(normalized, documentName)

  useEffect(() => {
    if (!enabled || !hasActiveBranding(normalized)) {
      return undefined
    }

    const restoreFavicon = applyFavicon(normalized.favicon)
    const restoreCss = applyBrandCssVariables(normalized.primary_color)
    const restoreTitle = brandingDocumentTitle
      ? applyDocumentTitle(brandingDocumentTitle)
      : () => undefined

    return () => {
      restoreFavicon()
      restoreCss()
      restoreTitle()
    }
  }, [
    enabled,
    normalized.favicon,
    normalized.logo,
    normalized.primary_color,
    normalized.title,
    normalized.contacts,
    brandingDocumentTitle,
  ])

  return normalized
}
